export class CouponInformation {
  code: string;
  message: string;
  cpnAvailableList: Coupon[];

  constructor(apiReslut: any) {
    this.code = apiReslut.code;
    this.message = apiReslut.message;
    this.cpnAvailableList = apiReslut.cpnAvailableList?.map((coupon) => {
      return new Coupon(coupon);
    });
  }
}

export class Coupon {
  cpnCd: string;
  offRate: string;
  ftrType: string;
  ftrUrl: string;
  cpnName: string;
  expl: string;
  limitTermFrom: string;
  limitTermTo: string;
  lowerLimitKbn: string;
  lowerLimitPrice: string;
  offTarget: string;
  cpnImagePath: string;
  minOffRate: string;
  ctgItemCdList: CatalogItem[];

  constructor(coupon: any) {
    this.cpnCd = coupon.cpnCd;
    this.offRate = coupon.offRate;
    this.ftrType = coupon.ftrType;
    this.ftrUrl = coupon.ftrUrl;
    this.cpnName = coupon.cpnName;
    this.expl = coupon.expl;
    this.limitTermFrom = coupon.limitTermFrom;
    this.limitTermTo = coupon.limitTermTo;
    this.lowerLimitKbn = coupon.lowerLimitKbn;
    this.lowerLimitPrice = coupon.lowerLimitPrice;
    this.offTarget = coupon.offTarget;
    this.cpnImagePath = coupon.cpnImagePath;
    this.minOffRate = coupon.minOffRate;
    this.ctgItemCdList = coupon.ctgItemCdList.map((catalogItem) => {
      return new CatalogItem(catalogItem);
    });
  }

  isBundleDiscountCoupon(): boolean {
    return this.offTarget === '3';
  }

  isOffNotTarget(catalogItemCode: string): boolean {
    const targetCatalogItem = this.ctgItemCdList.find(
      (ctgItem) => ctgItem.ctgItemCd === catalogItemCode
    );

    if (targetCatalogItem === undefined) {
      return false;
    }

    return targetCatalogItem.offNotTargetFlg === '1';
  }

  lowerLimitPriceCommaSeparate(): string {
    const lowerLimitPriceNum = Number(this.lowerLimitPrice);

    if (Number.isNaN(lowerLimitPriceNum)) {
      return '0';
    }

    return lowerLimitPriceNum.toLocaleString();
  }
}

export class CatalogItem {
  ctgItemCd: string;
  offNotTargetFlg: string;

  constructor(catalogItem: any) {
    this.ctgItemCd = catalogItem.ctgItemCd;
    this.offNotTargetFlg = catalogItem.offNotTargetFlg;
  }
}
